module.exports = __webpack_public_path__ + "img/gplay.3cf8ccb.svg";